import { render, staticRenderFns } from "./LeadTouch.vue?vue&type=template&id=338b9014&scoped=true&"
import script from "./LeadTouch.vue?vue&type=script&lang=js&"
export * from "./LeadTouch.vue?vue&type=script&lang=js&"
import style0 from "./LeadTouch.vue?vue&type=style&index=0&id=338b9014&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "338b9014",
  null
  
)

export default component.exports